import React, { FC } from 'react';
import { SystemButtonProps } from '../button.types';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import styles from './primary_button.module.scss';
import { BaseButton } from '../BaseButton';

export const PrimaryButton: FC<SystemButtonProps> = ({ dataName, ...rest }) => {
  return <BaseButton {...rest} className={styles.primary} name={dataName} />;
};

PrimaryButton.defaultProps = SystemButtonDefault;
